// ----------------------------------------------------------------------

export default function CssBaseline() {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          margin: 0,
          padding: 0,
          boxSizing: 'border-box',
          touchAction: 'manipulation',
          // Hide scrollbars everywhere — they render inside the WebView chrome
          scrollbarWidth: 'none',        // Firefox
          '&::-webkit-scrollbar': { display: 'none' }, // Chrome / Android WebView
        },
        html: {
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
          WebkitTapHighlightColor: 'transparent',
          // Prevent Android system font-size setting from blowing up the layout
          WebkitTextSizeAdjust: '100%',
          textSizeAdjust: '100%',
          // Overscroll must be on html AND body to suppress the native rubber-band
          overscrollBehavior: 'none',
        },
        body: {
          width: '100%',
          height: '100%',
          // antialiased looks sharp on iOS/macOS/desktop Chrome.
          // The Flutter Android WebView overrides this to 'auto' via JS injection
          // in web_view_mobile.dart so Android gets its native rendering instead.
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
          overscrollBehavior: 'none',
        },
        '#root': {
          width: '100%',
          height: '100%',
          overscrollBehavior: 'none',
        },
        // Note: the iOS keyboard fix lives entirely in
        // utils/iosKeyboardViewport.js and deliberately touches no layout at
        // all. An earlier version sized the page to the visual viewport from
        // here and produced a white band above the keyboard with the app
        // squeezed into a strip, because box-sizing is border-box and html,
        // body and #root are all height:100%. Do not reintroduce that.
        // Instant visual feedback on tap without the JS ripple overhead
        'button, [role="button"], a': {
          '&:active': {
            opacity: 0.75,
            transition: 'opacity 60ms ease',
          },
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        img: {
          display: 'block',
          maxWidth: '100%',
        },
      },
    },
  };
}
